import React, { useState, useEffect } from 'react';
import { Stepper, Step, StepLabel, Button, Typography, Box, CircularProgress, Paper, Grid, useTheme } from '@mui/material';
import ProfileSetup from './ProfileSetup';
import SpecialtyAndInterests from './SpecialtyAndInterests';
import WorkflowBuilder from './WorkflowBuilder';

const steps = ['Profile Setup', 'Specialty & Interests', 'Workflow Preferences'];

// DoctorOnboarding component for guiding doctors through initial setup
// TODO: add backend logic to check state of requirements 
// should go somewhere either to retrieve on start or to access on demand


///TODO: for workflow builder --for now we add a level of automation option for future development
//TODO: Evaluation per case and then on files add final diagnosis- label per image for future training and labeling 
//. pp IMAGE _ suggested diagnoses - Determined diagnoses of doctor - follow up notes and comments 
export default function DoctorOnboarding() {
  const theme = useTheme();
  const [progress, setProgress] = useState(0);
  const [activeFeature, setActiveFeature] = useState(0);

  // Features currently in development
  const features = [
    "Personalized User Profiles",
    "Specialty-Specific Clinical Workflows",
    "AI-Powered Clinical Decision Support",
    "End-to-End Case Lifecycle Management",
    "Intelligent Follow-Up & Patient Monitoring"
  ];

  // Simulate development progress
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => 
        prevProgress >= 100 ? 0 : prevProgress + 1
      );
    }, 800);
    
    const featureTimer = setInterval(() => {
      setActiveFeature((prevFeature) => 
        prevFeature >= features.length - 1 ? 0 : prevFeature + 1
      );
    }, 3000);
    
    return () => {
      clearInterval(timer);
      clearInterval(featureTimer);
    };
  }, []);

  return(
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      sx={{
        background: theme.palette.mode === 'light'
          ? 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)'
          : 'linear-gradient(135deg, #1e2329 0%, #121a24 100%)',
        padding: 4
      }}
    >
      <Paper 
        elevation={3} 
        sx={{ 
          p: 5, 
          borderRadius: 4, 
          maxWidth: 800,
          background: theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.9)'
            : 'rgba(32, 38, 45, 0.8)',
          backdropFilter: 'blur(8px)',
          border: `1px solid ${theme.palette.mode === 'light'
            ? 'rgba(209, 213, 219, 0.3)'
            : 'rgba(76, 86, 106, 0.3)'}`
        }}
      >
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6} textAlign="center">
            <Box position="relative" display="inline-flex">
              <CircularProgress 
                variant="determinate" 
                value={progress} 
                size={180}
                thickness={4}
                sx={{ color: theme.palette.primary.main }}
              />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: 'absolute',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography variant="caption" component="div" color="text.secondary" sx={{ fontSize: '1.2rem' }}>
                  {`${Math.round(progress)}%`}
                </Typography>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
              Doctor Onboarding
            </Typography>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              We're building something amazing
            </Typography>
            <Typography variant="body1" paragraph>
              Our development team is working hard to create a seamless onboarding experience tailored specifically for medical professionals.
            </Typography>
            
            <Box sx={{ mt: 3, mb: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                Currently developing:
              </Typography>
              <Box 
                sx={{ 
                  p: 2, 
                  mt: 1, 
                  border: `1px solid ${theme.palette.divider}`,
                  borderLeft: `4px solid ${theme.palette.primary.main}`,
                  borderRadius: 1,
                  bgcolor: theme.palette.mode === 'light'
                    ? 'rgba(63, 81, 181, 0.05)'
                    : 'rgba(63, 81, 181, 0.15)'
                }}
              >
                <Typography variant="body1">
                  {features[activeFeature]}
                </Typography>
              </Box>
            </Box>
            
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Expected completion: Q1 2026
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Stepper activeStep={-1} alternativeLabel sx={{ mt: 2 }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
